"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1.5A6.508 6.508 0 0 0 1.5 8c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5S11.584 1.5 8 1.5Zm0 14C3.864 15.5.5 12.136.5 8S3.864.5 8 .5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5Zm0-3.554A3.952 3.952 0 0 1 4.053 8c0-1.383.705-2.64 1.884-3.366l.524.853A2.93 2.93 0 0 0 5.053 8 2.95 2.95 0 0 0 8 10.946 2.95 2.95 0 0 0 10.946 8a2.962 2.962 0 0 0-1.468-2.55l.501-.865A3.96 3.96 0 0 1 11.946 8 3.95 3.95 0 0 1 8 11.946Zm.5-4.425h-1V2.772h1v4.749Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.2C6.045 1.2 1.2 6.045 1.2 12c0 5.955 4.845 10.8 10.8 10.8 5.955 0 10.8-4.845 10.8-10.8 0-5.955-4.845-10.8-10.8-10.8Zm0 22.725C5.425 23.925.075 18.575.075 12 .075 5.425 5.425.075 12 .075c6.575 0 11.925 5.35 11.925 11.925 0 6.575-5.35 11.925-11.925 11.925Zm0-5.768A6.164 6.164 0 0 1 5.843 12a6.17 6.17 0 0 1 3.629-5.615l.463 1.025A5.043 5.043 0 0 0 6.968 12 5.038 5.038 0 0 0 12 17.032 5.038 5.038 0 0 0 17.032 12a5.044 5.044 0 0 0-2.961-4.587l.463-1.025A6.171 6.171 0 0 1 18.157 12 6.164 6.164 0 0 1 12 18.157Zm.563-7.184h-1.125v-7.21h1.125v7.21Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16 1.6C8.06 1.6 1.6 8.06 1.6 16S8.06 30.4 16 30.4 30.4 23.94 30.4 16 23.94 1.6 16 1.6Zm0 30.3C7.233 31.9.1 24.767.1 16S7.233.1 16 .1 31.9 7.233 31.9 16 24.767 31.9 16 31.9Zm0-7.691c-4.526 0-8.209-3.683-8.209-8.209a8.227 8.227 0 0 1 4.838-7.487l.617 1.367A6.723 6.723 0 0 0 9.291 16a6.717 6.717 0 0 0 6.71 6.709A6.717 6.717 0 0 0 22.708 16a6.725 6.725 0 0 0-3.948-6.116l.618-1.367A8.228 8.228 0 0 1 24.21 16c0 4.526-3.683 8.209-8.209 8.209Zm.75-9.579h-1.5V5.017h1.5v9.613Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.075 24C.075 37.192 10.807 47.925 24 47.925c13.192 0 23.925-10.733 23.925-23.925C47.925 10.807 37.192.075 24 .075 10.807.075.075 10.807.075 24Zm1.875 0C1.95 11.842 11.842 1.95 24 1.95c12.158 0 22.05 9.892 22.05 22.05 0 12.158-9.892 22.05-22.05 22.05-12.16 0-22.05-9.892-22.05-22.05ZM24 36.255c-6.757 0-12.255-5.498-12.255-12.255 0-4.812 2.835-9.2 7.224-11.178l.855-.386.77 1.71-.855.385A10.405 10.405 0 0 0 13.62 24c0 5.723 4.657 10.38 10.38 10.38 5.724 0 10.381-4.657 10.381-10.38 0-4.071-2.398-7.786-6.108-9.464l-.854-.387.773-1.707.854.386A12.286 12.286 0 0 1 36.256 24c0 6.757-5.498 12.255-12.256 12.255Zm.938-14.534h-1.875V7.536h1.875v14.185Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M.1 32C.1 49.59 14.41 63.9 32 63.9c17.59 0 31.9-14.31 31.9-31.9C63.9 14.41 49.59.1 32 .1 14.41.1.1 14.41.1 32Zm2.5 0C2.6 15.79 15.789 2.6 32 2.6c16.21 0 29.4 13.19 29.4 29.4 0 16.211-13.19 29.4-29.4 29.4C15.789 61.4 2.6 48.211 2.6 32ZM32 48.34c-9.01 0-16.34-7.33-16.34-16.34 0-6.416 3.78-12.266 9.63-14.904l1.14-.514 1.028 2.28-1.14.513A13.873 13.873 0 0 0 18.16 32c0 7.631 6.209 13.84 13.84 13.84 7.632 0 13.84-6.209 13.84-13.84a13.874 13.874 0 0 0-8.143-12.618l-1.14-.516 1.032-2.277 1.139.515A16.381 16.381 0 0 1 48.34 32c0 9.01-7.331 16.34-16.341 16.34Zm1.25-19.378h-2.5V10.049h2.5v18.913Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconPowerOn = function IconPowerOn(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Power On' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "PowerOn"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconPowerOn.sizes = [16, 24, 32, 48, 64];
IconPowerOn.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconPowerOn;
exports.default = _default;